import { Component, ElementRef, EventEmitter, OnDestroy, Output, ViewChild } from '@angular/core';
import {
  CustomFacade,
  ProjectsFacade,
  SharedFacade,
  customDecode,
  debounce,
  decrypt,
  delayedFunctionCall,
  formatNumber,
  getRolesAndPermission,
  onKeyDown,
  scrollToSpecific,
} from '@piqet-angular/data';
import {
  AccessPermissionService,
  CustomModalService,
  DistanceTypeEnum,
  GuideTourEnum,
  commonEnum,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ColDef } from 'ag-grid-community';
import { ProjectScenarioWholesaleDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-scenario-wholesale-data/project-scenario-wholesale-data-grid.service';
import { cloneDeep } from 'lodash';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GridIconComponent } from '../grid-icon/grid-icon.component';
import { CustomStorageDataGridService, CustomTrucksDataGridService } from '@piqet-angular/features';
import { TitleCasePipe } from '@angular/common';
import { CustomService } from 'libs/data/src/lib/services/custom/custom.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { Observable, Subject, Subscription, forkJoin, take } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { MapsAPILoader } from '@agm/core';
import { InlineActionButtonComponent } from '../inline-action-button/inline-action-button.component';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'piqet-angular-new-add-project-scenario-wholesale-data',
  templateUrl: './new-add-project-scenario-wholesale-data.component.html',
  styleUrls: ['./new-add-project-scenario-wholesale-data.component.scss'],
  providers: [TitleCasePipe],
})
export class NewAddProjectScenarioWholesaleDataComponent implements OnDestroy {
  modalLabel: any;
  pageNumber = 1;
  searchValue: any;
  selectedCities: any;
  myProjectScenarioWholesaleForm!: FormGroup;
  submitted!: boolean;
  secondaryMarketDropdown: any;
  processColumnDef: any;
  setDestinationsubmitted: any;
  distanceColumnDefs: any;
  keyword = 'name';
  transportColumnDefs!: ColDef[];
  componentItems: any;
  selectedWholesaleItem: any;
  customTransportList: any;
  isCalcByPallet = false;
  isProductContent = false;
  selectedBox: any;
  isShowDistantField = false;
  wholesaleProcess: any;
  customWholesaleProcess: any;
  isCalcByPalletOrigin: any = false;
  selectedCustomStorageItem: any;
  isShowCustomTransportList = false;
  transportModeListDistance: any;
  transportationId: any;
  distanceBlack = './assets/icons/BasedOnDistance.png';
  distanceWhite = './assets/icons/BasedOnDistanceWhite.png';
  locationBlack = './assets/icons/BasedOnLocations.png';
  loactionWhite = './assets/icons/BasedOnLocationsWhite.png';
  customBlack = './assets/icons/CustomScenarios.png';
  customWhite = './assets/icons/CustomScenariosWhite.png';
  cityId: any;
  location: any;
  transportModeId: any;
  transportModeName: any;
  transportModeDescription: any;
  transportFreightModeList: any;
  isShowPort = false;
  secondaryMarketValueItem: any;
  customtransportScenarioId: any;
  customFreightColumnDefs: any;
  productClass: any;
  wholesaleData: any;
  isCustomTruck: any = false;
  isCustomTruckDistance: any = false;
  transportModeList: any;
  customTransportModeList: any;
  palletItems: any;
  secondaryMarketStr = 'Sale to secondary market';
  setOriginsubmitted: any;
  productLossItems: any;
  isDistance: any;
  endOfLifeList: any;
  projectId: any;
  selectedStorageItem: any;
  scenarioId: any;
  maxLoad: any;
  regionListData: any;
  selectedRegion: any;
  selectedProductLossItem: any;
  selectedPackagingLossItem: any;
  setManualLocationDis: any;
  isCostTurnOff: any;
  selectCustom = false;
  selectDistance = false;
  selectLocation = false;
  messageType: any;
  isValidPort: any;
  lastItem: any;
  seaDistance: any;
  keywordAuto = '';
  wholeData: any = [
    {
      displayName: 'Based on location',
      img: this.locationBlack,
      widthImg: 19,
      heightImg: 26,
      type: 'location',
      transportaionId: 2,
    },
    {
      displayName: 'Based on distance',
      img: this.distanceBlack,
      widthImg: 26,
      heightImg: 25,
      type: 'distance',
      transportaionId: 3,
    },
    {
      displayName: 'Custom freight scenarios',
      img: this.customBlack,
      widthImg: 22,
      heightImg: 26,
      type: 'custom',
      transportaionId: 4,
    },
  ];
  TransportationEnum = [
    { Description: 'Material Default', id: 1 },
    { Description: 'Manual Locations', display: 'location', id: 2 },
    { Description: 'Manual Distances', display: 'distance', id: 3 },
    { Description: 'Custom Transport Mode', display: 'custom', id: 4 },
  ];
  transportaionId: any; // For transportation ID (Manual location, distance, custom)
  @Output() saveNewMyProjectWholesaleEvent = new EventEmitter<any>();
  @ViewChild('autoForOrigin') autoForOrigin: any;
  @ViewChild('autoForDestination') autoForDestination: any;
  @ViewChild('popoverOne') popoverOne!: NgbPopover;
  @ViewChild('popoverTwo') popoverTwo!: NgbPopover;
  isLoading = false;
  frameworkComponents = {
    inlineActionButtonComponent: InlineActionButtonComponent,
    iconsOfTransport: GridIconComponent,
  };
  packageScenarioId: any;
  eId: any;
  checkIsOrginBtn = true;
  isCheckEditManudalDist = false;
  isCheckUpdateDestination = false;
  isCheckUpdateOrigin = false;
  subscriptionProjectWholesaleData!: Subscription;
  projectWholesaleeditData: any;
  setDestinationLocationData: any;
  getOriginAndDestinationEditData: any;
  subscriptionCheckDeleteRowData!: Subscription;
  subscriptionProjectRetailManudalDistanceData!: Subscription;
  subscriptionSaveProjectManualDistanceWholesaleData!: Subscription;
  clearInputFieldProjectRetailManualDistanceWholesale!: Subscription;
  setApiResDistance = false;
  setManualLocationDisForNextRecord: any;
  customFreightSelectData: any;
  checkAddCustomFreight = false;
  private searchSubject = new Subject<string>();
  private readonly debounceTimeMs = 300; // Set the debounce time (in milliseconds)
  search$!: Observable<string>;
  showEdit = false;
  showCustomStorageAccess = false;
  showCustomTruckAccess = false;
  showCustomTransportAccess = false;
  secondaryDefaultValue = 10;
  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    public projectFacade: ProjectsFacade,
    private sharedFacade: SharedFacade,
    private customTrucksDataGridService: CustomTrucksDataGridService,
    private mapsAPILoader: MapsAPILoader,
    private projectScenarioWholesaleDataGridService: ProjectScenarioWholesaleDataGridService,
    public projectsService: ProjectsService,
    private router: Router,
    public route: ActivatedRoute,
    private customFacade: CustomFacade,
    private accessService: AccessPermissionService,
    private toaster: ToastrService,
    private sharedService: SharedService,
    private customService: CustomService,
    private spinnerService: NgxSpinnerService
  ) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.wholesaleData = this.modal?.modalService?.config?.initialState?.['wholesaleData'];
    this.transportaionId =
      this.modalLabel == 'Review wholesale' ? this.wholesaleData.transportationId : 2;
    this.palletItems = this.wholesaleData?.palletTypeItems;
    this.wholesaleProcess = this.wholesaleData.storageIdentifierItems;
    this.customWholesaleProcess = this.wholesaleData.customStorageItems;
    this.transportationId = this.wholesaleData.transportationId || 2; // For selected BOXES
    this.endOfLifeList = this.wholesaleData.endofLifeIdentifierItems;
    this.productLossItems = this.wholesaleData.productLossWasteDisposalItems;
    this.transportFreightModeList = this.wholesaleData.customtransportScenarioItems;
    this.customtransportScenarioId = this.wholesaleData?.customtransportScenarioId;
    this.checkAddCustomFreight = this.customtransportScenarioId ? true : false;
    this.regionListData = this.wholesaleData.regionItems;
    this.transportModeList = this.wholesaleData?.transportModeItems;
    this.customTransportModeList = this.wholesaleData?.customTruckItems;
    this.isCostTurnOff = !this.wholesaleData?.isCostTrunOff;
    this.transportModeListDistance = this.wholesaleData?.transportModeItems;
    this.secondaryMarketValueItem = this.wholesaleData?.secondaryMarketvalueItem;
    this.transportColumnDefs = this.projectScenarioWholesaleDataGridService.locationColumn();
    this.distanceColumnDefs = cloneDeep(this.transportColumnDefs).splice(1);
    this.distanceColumnDefs[2].editable = false;
    this.customFreightColumnDefs =
      this.projectScenarioWholesaleDataGridService.customSiteTransportColumn();
    this.selectedBox = this.TransportationEnum.find((x: any, index: any) => {
      return this.transportationId == this.TransportationEnum[index].id;
    });

    this.route.queryParams.subscribe((values: any) => {
      let value: any = decrypt(values.param ? values.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.packageScenarioId = value['packageScenarioId'];
      this.eId = value['eId'];
    });

    this.setStorageValue();
    this.setCountryValue();
    this.setProductLossValue();
    this.setPackagingLossValue();
  }

  async fingOriginAndDestination(id: any) {
    this.getOriginAndDestinationEditData = id;
    if (this.checkIsOrginBtn) {
      this.isCheckUpdateOrigin = true;
      this.myProjectScenarioWholesaleForm.patchValue({
        origin: this.getOriginAndDestinationEditData,
      });
    } else {
      this.isCheckUpdateDestination = true;
      this.myProjectScenarioWholesaleForm.patchValue({
        destination: this.getOriginAndDestinationEditData,
      });
    }
  }

  ngOnInit() {
    this.showEdit = this.accessService.hasPermission('edit', '', 'packaging');
    this.showCustomStorageAccess = getRolesAndPermission(
      rolesModuleName.customStorage,
      mainModuleName.customModule
    )?.isOverview;
    this.showCustomTruckAccess = getRolesAndPermission(
      rolesModuleName.customTrucks,
      mainModuleName.customModule
    )?.isOverview;
    this.showCustomTransportAccess = getRolesAndPermission(
      rolesModuleName.customTransportScenario,
      mainModuleName.customModule
    )?.isOverview;

    this.projectFacade.locationWholesale$.pipe(take(1)).subscribe((data: any) => {
      this.checkIsOrginBtn = false;
    });
    this.search$ = debounce(this.searchSubject.asObservable(), this.debounceTimeMs);
    this.search$.subscribe(searchValue => {
      this.searchCities(searchValue);
    });
    this.subscriptionCheckDeleteRowData =
      this.projectScenarioWholesaleDataGridService.checkDeleteRowWholesaleData$.subscribe(
        (check: any) => {
          this.myProjectScenarioWholesaleForm.controls['origin'].setValue(null);
          this.myProjectScenarioWholesaleForm.controls['destination'].setValue(null);
          this.myProjectScenarioWholesaleForm.controls['transportModeForLocation'].setValue(null);
          this.myProjectScenarioWholesaleForm.controls['transportModeForDistance'].setValue(null);
          this.myProjectScenarioWholesaleForm.controls['distance'].setValue('');
          this.myProjectScenarioWholesaleForm.controls['palletLoad'].setValue(0);
          this.myProjectScenarioWholesaleForm.controls['palletsInTruck'].setValue(0);
          this.myProjectScenarioWholesaleForm.controls['loadInTruck'].setValue(0);
          this.myProjectScenarioWholesaleForm.controls['percentLoaded'].setValue(0);

          this.myProjectScenarioWholesaleForm.controls['palletLoadOrigin'].setValue(0);
          this.myProjectScenarioWholesaleForm.controls['palletsInTruckOrigin'].setValue(0);
          this.myProjectScenarioWholesaleForm.controls['loadInTruckOrigin'].setValue(0);
          this.myProjectScenarioWholesaleForm.controls['percentLoadedOrigin'].setValue(0);
          check[2] && check[0].length > 0 && this.deleteSetDistanceRecord(check[0], check[1]);
          this.isCheckUpdateDestination = false;
          this.isCheckUpdateOrigin = false;
          this.isCheckEditManudalDist = false;
          this.isCalcByPalletOrigin = false;
          this.isCalcByPallet = false;
        }
      );

    this.clearInputFieldProjectRetailManualDistanceWholesale =
      this.projectScenarioWholesaleDataGridService.clearInputFieldProjectManualDistanceWholesaleData$.subscribe(
        (check: any) => {
          this.myProjectScenarioWholesaleForm.controls['origin'].setValue(null);
          this.myProjectScenarioWholesaleForm.controls['destination'].setValue(null);
          this.myProjectScenarioWholesaleForm.controls['transportModeForLocation'].setValue(null);
          this.myProjectScenarioWholesaleForm.controls['transportModeForDistance'].setValue(null);
          this.myProjectScenarioWholesaleForm.controls['distance'].setValue('');
          this.isCheckUpdateDestination = false;
          this.isCheckUpdateOrigin = false;
          this.isCheckEditManudalDist = false;
          this.checkIsOrginBtn = false;
        }
      );

    this.subscriptionSaveProjectManualDistanceWholesaleData =
      this.projectScenarioWholesaleDataGridService.saveProjectManualDistanceWholesaleData$.subscribe(
        (editData: any) => {
          this.projectFacade.locationWholesale$.pipe(take(1)).subscribe(async (data: any) => {
            data.length == 1 && editData[1] == 'manualLocation'
              ? this.setLocation()
              : !editData[0].isCheckManualDis
              ? this.setDestination()
              : this.addTransportLeg();
          });
        }
      );
    this.subscriptionProjectWholesaleData =
      this.projectScenarioWholesaleDataGridService.editProjectWholesaleSubData$.subscribe(
        async (editData: any) => {
          this.projectWholesaleeditData = editData[0];
          this.isCustomTruck = editData[0].isCustomTruck;
          this.isCalcByPalletOrigin = editData[0].isPalletLoad;
          this.isCalcByPallet = editData[0].isPalletLoad;
          this.transportModeId = editData[0].transportModeId;
          const distanceManualLocationvalue =
            typeof editData[0].distance === 'string'
              ? editData[0]?.distance?.substring(0, editData[0]?.distance?.indexOf(' '))
              : 0;
          this.myProjectScenarioWholesaleForm.controls['distanceManulaLocation'].setValue(
            distanceManualLocationvalue
          );
          if (editData[0].isCheckManualDis) {
            this.isCheckEditManudalDist = true;
            this.isCustomTruckDistance = editData[0].isCustomTruck;
            this.myProjectScenarioWholesaleForm.controls['distance'].setValue(editData[0].distance);
            if (this.isCalcByPallet && this.isCustomTruckDistance) {
              this.myProjectScenarioWholesaleForm.controls['palletLoad'].setValue(
                editData[0].palletLoad
              );
              this.myProjectScenarioWholesaleForm.controls['palletsInTruck'].setValue(
                editData[0].palletInTruck
              );
              this.myProjectScenarioWholesaleForm.controls['loadInTruck'].setValue(
                editData[0].loadInTruck
              );
              this.myProjectScenarioWholesaleForm.controls['percentLoaded'].setValue(
                editData[0].persanteageMassLoad
              );
            }
          }
          if (this.isCalcByPalletOrigin && this.isCustomTruck) {
            this.myProjectScenarioWholesaleForm.controls['palletLoadOrigin'].setValue(
              editData[0].palletLoad
            );
            this.myProjectScenarioWholesaleForm.controls['palletsInTruckOrigin'].setValue(
              editData[0].palletInTruck
            );
            this.myProjectScenarioWholesaleForm.controls['loadInTruckOrigin'].setValue(
              editData[0].loadInTruck
            );
            this.myProjectScenarioWholesaleForm.controls['percentLoadedOrigin'].setValue(
              editData[0].persanteageMassLoad
            );
          }
          this.transportModeListDistance = this.isCustomTruckDistance
            ? this.customTransportModeList
            : this.wholesaleData.transportModeItems;
          this.transportModeList = this.isCustomTruck
            ? this.customTransportModeList
            : this.wholesaleData.transportModeItems;
          if (editData[1]) {
            this.projectFacade.locationWholesale$.pipe(take(1)).subscribe(async (data: any) => {
              this.checkIsOrginBtn = data.length <= 1 ? true : false;
            });
            editData[0] = { ...editData[0] };
            editData[0].name = editData[0].originName;
            await this.fingOriginAndDestination(editData[0]);
            this.getLastItem();
            const location = editData[0].isCustomTruck
              ? this.customTransportModeList
              : this.wholesaleData.transportModeItems;
            const locationId = editData[0].isCustomTruck
              ? editData[0].customTruckId
              : editData[0].transportModeId;
            location.map((data: any) => {
              return {
                ...data,
                id: data.truckId,
              };
            });
            location.map((x: any) => {
              if (x.id == locationId) {
                this.setDestinationLocationData = x;
                if (editData[0].isCheckManualDis) {
                  this.myProjectScenarioWholesaleForm.patchValue({
                    transportModeForDistance: this.setDestinationLocationData,
                  });
                } else {
                  this.myProjectScenarioWholesaleForm.patchValue({
                    transportModeForLocation: this.setDestinationLocationData,
                  });
                }
              }
            });
          }
        }
      );
    this.myProjectScenarioWholesaleForm = this.formBuilder.group({
      origin: [null],
      distance: [''],
      destination: [null],
      // pallet: [null],
      storageDays: [null, Validators.required],
      productPercentageLoss: [],
      transportModeForLocation: [null],
      distanceManulaLocation: [''],
      transportModeForDistance: [null],
      customFreight: [null],
      storageItems: [null],
      volumeRatio: [this.wholesaleData.volumeRatio, Validators.required],
      endOfLifeItems: [null],
      productLossList: [null],
      regionList: [null, Validators.required],
      palletLoad: [{ value: 0, disabled: true }],
      palletsInTruck: [0],
      percentageProductLoss: [0, [Validators.min(0), Validators.max(100)]],
      loadInTruck: [{ value: 0, disabled: true }],
      percentLoaded: [{ value: 0, disabled: true }],
      palletLoadOrigin: [{ value: 0, disabled: true }],
      palletsInTruckOrigin: [0],
      loadInTruckOrigin: [{ value: 0, disabled: true }],
      percentLoadedOrigin: [{ value: 0, disabled: true }],
      secondaryMarket: [
        this.wholesaleData?.percentageOfReusedProduct &&
        this.wholesaleData?.percentageOfReusedProduct != 0
          ? this.wholesaleData?.percentageOfReusedProduct
          : this.secondaryDefaultValue,
      ],
      wholesaleCost: [this.wholesaleData?.cost || null],
    });
    this.setFormValues();
    !!this.customtransportScenarioId && this.customScenarioItem();
    // Initialize validators based on existing product loss value
    this.initProductLossValidators();
  }

  initProductLossValidators() {
    const productLossValue =
      this.myProjectScenarioWholesaleForm.controls['percentageProductLoss'].value;
    if (productLossValue > 0) {
      this.myProjectScenarioWholesaleForm.controls['productLossList'].setValidators(
        Validators.required
      );
      this.myProjectScenarioWholesaleForm.controls['endOfLifeItems'].setValidators(
        Validators.required
      );
    } else {
      this.myProjectScenarioWholesaleForm.controls['productLossList'].removeValidators(
        Validators.required
      );
      this.myProjectScenarioWholesaleForm.controls['endOfLifeItems'].removeValidators(
        Validators.required
      );
    }
    this.myProjectScenarioWholesaleForm.controls['endOfLifeItems'].updateValueAndValidity();
    this.myProjectScenarioWholesaleForm.controls['productLossList'].updateValueAndValidity();
  }
  customScenarioItem() {
    this.wholesaleData.customtransportScenarioItems.find((x: any) => {
      if (this.customtransportScenarioId == x.id) {
        this.customFreightSelectData = x;
        this.myProjectScenarioWholesaleForm.patchValue({ customFreight: x });
      }
    });
  }

  noSpecialKeys(event: any) {
    const allowedKeys = /^[0-9.]$/; // RegEx to allow digits and one decimal point

    if (
      event.key === 'Backspace' ||
      event.key === 'Delete' ||
      event.key === 'ArrowUp' ||
      event.key === 'ArrowRight' ||
      event.key === 'ArrowDown' ||
      event.key === 'ArrowLeft'
    )
      return;

    if (!allowedKeys.test(event.key)) {
      event.preventDefault();
    }

    // logic to allow only one decimal point
    const input = event.target.value;
    const hasDecimalPoint = input.includes('.');

    if (event.key === '.' && hasDecimalPoint) {
      event.preventDefault();
    }
  }

  getLastItem() {
    this.projectFacade.locationWholesale$.pipe(take(1)).subscribe((data: any) => {
      this.lastItem = this.isCheckUpdateDestination
        ? data[
            data.findIndex((item: any) => item.index === this.projectWholesaleeditData.index) - 1
          ]
        : data[data?.length - 1];
    });
  }
  changeTransportMode(event: any) {
    if (event?.id) {
      this.transportModeId = event.id;
      this.transportModeName = event.name;
      this.transportModeDescription = event.description;
      this.getLastItem();
    }
    if (this.isCustomTruck && event?.id) {
      this.projectsService.getTruckMassLoad(event.id).subscribe((res: any) => {
        this.myProjectScenarioWholesaleForm.controls['loadInTruckOrigin'].setValue(
          res.data.maxLoad
        );
        this.myProjectScenarioWholesaleForm.controls['percentLoadedOrigin'].setValue(
          res.data.percenteageMassLoad
        );
      });
    }
  }

  async calculateDistance(lastItem?: any) {
    const payload = {
      origin: lastItem.originName,
      destination: this.myProjectScenarioWholesaleForm.controls['destination'].value.name,
      destinationId: Number(
        this.myProjectScenarioWholesaleForm.controls['destination'].value.idStr
      ),
      iscustomtruck: this.isCustomTruck,
      transportmodeId: this.transportModeId,
      customTransoportScenarioDetails: [
        {
          id: 0,
          cityId: lastItem.originId,
          cityName: lastItem.originName,
          transportModeName: this.transportModeName,
          customTransportScenarioId: 0,
          imageName: lastItem.description,
        },
      ],
    };
    const response = await this.customService.getSeaDistanceForTransportAsync(payload);
    if (
      (response.data.distance >= 0 && response.data.isShip) ||
      response?.message.includes('must be a valid Port')
    ) {
      this.myProjectScenarioWholesaleForm.controls['distance'].setValue(response?.data.distance);
      const setManualLocationDis = response?.data.distance;
      this.setManualLocationDis = setManualLocationDis;
      this.isValidPort = response.message;
      this.messageType = response.messageType;
      // this.customFacade.setCustomTransportError('');
      return response;
    } else {
      await this.getCalculateDis();
    }
  }

  async getCalculateDis() {
    await this.mapsAPILoader.load();
    const service = new google.maps.DistanceMatrixService();
    const request: any = {
      origins: [this.lastItem.originName],
      destinations: [this.myProjectScenarioWholesaleForm.controls['destination'].value.name],
      travelMode: 'DRIVING',
    };
    return new Promise((resolve, reject) => {
      service.getDistanceMatrix(request, (response: any, status: any) => {
        if (status === 'OK') {
          const distance = response.rows[0].elements[0].distance?.text
            ? response.rows[0].elements[0].distance?.text
            : '0 km';
          this.myProjectScenarioWholesaleForm.controls['distance'].setValue(distance);
          this.setManualLocationDis = distance;
          resolve(distance);
        } else {
          reject(new Error(`Distance calculation failed with status: ${status}`));
        }
      });
    });
  }

  LoadInTruckCalculation() {
    const total =
      this.myProjectScenarioWholesaleForm.controls['palletLoad'].value *
      this.myProjectScenarioWholesaleForm.controls['palletsInTruck'].value;
    if (total > this.maxLoad) {
      this.myProjectScenarioWholesaleForm.controls['loadInTruck'].setValue(this.maxLoad);
      this.sharedFacade.warningToaster(
        'The suggested load is more than the capacity of the truck, so the truck load will be set to 100% capacity. Consider revising the load data.'
      );
    } else {
      this.myProjectScenarioWholesaleForm.controls['loadInTruck'].setValue(Math.round(total * 1e9) / 1e9);
    }
    let percentageMassLoad =
      (this.myProjectScenarioWholesaleForm.controls['loadInTruck'].value / this.maxLoad) * 100;
    if (isNaN(percentageMassLoad) || percentageMassLoad == Infinity) {
      percentageMassLoad = 0;
      this.myProjectScenarioWholesaleForm.controls['percentLoaded'].setValue(0);
    } else {
      this.myProjectScenarioWholesaleForm.controls['percentLoaded'].setValue(
        Math.round(percentageMassLoad * 1e9) / 1e9
      );
    }
  }

  LoadInTruckCalculationOrigin() {
    const total =
      this.myProjectScenarioWholesaleForm.controls['palletLoadOrigin'].value *
      this.myProjectScenarioWholesaleForm.controls['palletsInTruckOrigin'].value;
    if (total > this.maxLoad) {
      this.myProjectScenarioWholesaleForm.controls['loadInTruckOrigin'].setValue(this.maxLoad);
      this.toaster.warning(
        'The suggested load is more than the capacity of the truck, so the truck load will be set to 100% capacity. Consider revising the load data.'
      );
    } else {
      this.myProjectScenarioWholesaleForm.controls['loadInTruckOrigin'].setValue(Math.round(total * 1e9) / 1e9);
    }
    let percentageMassLoad =
      (this.myProjectScenarioWholesaleForm.controls['loadInTruckOrigin'].value / this.maxLoad) *
      100;
    if (isNaN(percentageMassLoad) || percentageMassLoad == Infinity) {
      percentageMassLoad = 0;
      this.myProjectScenarioWholesaleForm.controls['percentLoadedOrigin'].setValue(0);
    } else {
      this.myProjectScenarioWholesaleForm.controls['percentLoadedOrigin'].setValue(
        Math.round(percentageMassLoad * 1e9) / 1e9
      );
    }
  }

  changeCustomTruck(event: any) {
    this.isCustomTruck = event.target.checked ? true : false;
    this.transportColumnDefs = this.projectScenarioWholesaleDataGridService.locationColumn();
    this.transportColumnDefs.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.transportModeList = this.isCustomTruck
      ? this.customTransportModeList
      : this.wholesaleData.transportModeItems;
    this.myProjectScenarioWholesaleForm.controls['transportModeForLocation'].setValue(null);
  }

  changeCustomTruckDistance(event: any) {
    this.isCustomTruckDistance = event.target.checked ? true : false;
    this.transportColumnDefs = this.projectScenarioWholesaleDataGridService.locationColumn();
    this.distanceColumnDefs = cloneDeep(this.transportColumnDefs).splice(1);
    this.distanceColumnDefs[2].editable = false;
    this.distanceColumnDefs.forEach((column: any) => {
      if (this.isCustomTruckDistance && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruckDistance && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.transportModeListDistance = this.isCustomTruckDistance
      ? this.customTransportModeList
      : this.wholesaleData.transportModeItems;
    this.myProjectScenarioWholesaleForm.controls['transportModeForDistance'].setValue(null);
  }

  setLocation() {
    // For setting Origin
    this.setOriginsubmitted = true;

    if (this.myProjectScenarioWholesaleForm.controls['origin']?.value?.hasOwnProperty('name')) {
      const payload = {
        id: 0,
        originName: this.location ? this.location : this.projectWholesaleeditData.originName,
        distance: '',
        originId: this.cityId,
      };
      this.projectFacade.locationProcessWholesaleActions(
        payload,
        this.isCheckUpdateOrigin ? 'edit' : 'add'
      );
      this.myProjectScenarioWholesaleForm.controls['origin'].reset();
      this.setOriginsubmitted = false;
      this.checkIsOrginBtn = false;
      this.isCheckUpdateOrigin = false;
    }
  }

  editWholesaleDistance(record: any) {
    this.projectFacade.wholesaleInlineTransportProcess(record[1], 'edit');
  }

  getMassLoad(event: any) {
    if (event?.id) {
      this.projectsService.getTruckMassLoad(event.id || event.truckId).subscribe((res: any) => {
        this.myProjectScenarioWholesaleForm.controls['loadInTruck'].setValue(res.data.maxLoad);
        this.myProjectScenarioWholesaleForm.controls['percentLoaded'].setValue(
          res.data.percenteageMassLoad
        );
        this.maxLoad = res.data.maxLoad;
      });
    }
  }

  manualLocation(data: any) {
    this.selectLocation = false;
    this.selectDistance = false;
    this.selectCustom = false;
    this.isCheckEditManudalDist = false;
    this.isCheckUpdateOrigin = false;
    this.isCheckUpdateDestination = false;
    this.isCustomTruck = false;
    this.transportColumnDefs = this.projectScenarioWholesaleDataGridService.locationColumn();
    this.transportColumnDefs.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.isCalcByPalletOrigin = false;
    this.isCalcByPallet = false;
    this.wholeData[0]['img'] = this.locationBlack;
    this.wholeData[1]['img'] = this.distanceBlack;
    this.wholeData[2]['img'] = this.customBlack;
    switch (data.type) {
      case 'location':
        this.wholeData[0]['img'] = this.loactionWhite;
        this.selectedBox.id = 2;
        this.selectLocation = true;
        this.isShowCustomTransportList = false;
        this.myProjectScenarioWholesaleForm.controls['origin'].setValue(null);
        this.myProjectScenarioWholesaleForm.controls['destination'].setValue(null);
        this.myProjectScenarioWholesaleForm.controls['transportModeForLocation'].reset();
        this.transportaionId = 2;
        this.customTransportList = null;
        this.transportModeList = this.wholesaleData.transportModeItems;
        this.isDistance = false;
        this.isCustomTruck = false;
        this.isCustomTruckDistance = false;
        this.projectFacade.locationWholesale$.pipe(take(1)).subscribe((data: any) => {
          if (data && data.length > 0) {
            const updatedData = data.map((item: any) => ({
              ...item,
              enableEditing: false,
            }));
            this.projectFacade.locationProcessWholesaleActions(updatedData, 'reset');
          }
        });
        break;
      case 'distance':
        this.wholeData[1]['img'] = this.distanceWhite;
        this.selectedBox.id = 3;
        this.selectDistance = true;
        this.isShowDistantField = false;
        this.isShowCustomTransportList = false;
        this.transportaionId = 3;
        this.customTransportList = null;
        this.transportModeList = this.wholesaleData.transportModeItems;
        this.transportModeListDistance = this.wholesaleData.transportModeItems;
        this.myProjectScenarioWholesaleForm.controls['destination'].setValue(null);
        this.myProjectScenarioWholesaleForm.controls['transportModeForDistance'].setValue(null);
        this.myProjectScenarioWholesaleForm.controls['distanceManulaLocation'].setValue('');
        this.myProjectScenarioWholesaleForm.controls['distance'].setValue(null);
        this.setOriginsubmitted = false;
        this.setDestinationsubmitted = false;
        this.isDistance = false;
        this.isCustomTruck = false;
        this.isCustomTruckDistance = false;
        this.projectFacade.distanceWholesale$.pipe(take(1)).subscribe((data: any) => {
          if (data && data.length > 0) {
            const updatedData = data.map((item: any) => ({
              ...item,
              enableEditing: false,
            }));
            this.projectFacade.distanceWholesaleActions(updatedData, 'reset');
          }
        });
        break;
      case 'custom':
        this.wholeData[2]['img'] = this.customWhite;
        this.selectedBox.id = 4;
        this.selectCustom = true;
        this.isShowDistantField = false;
        this.transportaionId = 4;
        this.checkAddCustomFreight = false;
        this.isCustomTruck = false;
        this.isCustomTruckDistance = false;
        this.myProjectScenarioWholesaleForm.controls['origin'].setValue(null);
        this.myProjectScenarioWholesaleForm.controls['destination'].setValue(null);
        this.myProjectScenarioWholesaleForm.controls['distance'].setValue(null);
        this.myProjectScenarioWholesaleForm.controls['transportModeForLocation'].reset();
        this.myProjectScenarioWholesaleForm.controls['distanceManulaLocation'].setValue('');
        this.addCustomFreight();
        break;
      default:
        break;
    }
  }

  async getCalculateDisForNextRecord(lastItem: any, nextItem: any) {
    await this.mapsAPILoader.load();
    const service = new google.maps.DistanceMatrixService();
    const request: any = {
      origins: [lastItem],
      destinations: [nextItem.originName],
      travelMode: 'DRIVING',
    };
    return new Promise((resolve, reject) => {
      service.getDistanceMatrix(request, (response: any, status: any) => {
        if (status === 'OK') {
          const distance = response.rows[0].elements[0].distance?.text
            ? response.rows[0].elements[0].distance?.text
            : '0 km';
          this.setManualLocationDisForNextRecord = distance;
          resolve(distance);
        } else {
          reject(new Error(`Distance calculation failed with status: ${status}`));
        }
      });
    });
  }

  changeNextRecordDistance() {
    this.projectFacade.locationWholesale$.pipe(take(1)).subscribe(async (data: any) => {
      const startIndex = data.findIndex(
        (item: any) => item.index === this.projectWholesaleeditData.index
      ); // Index to start checking after
      if (this.isCheckUpdateDestination && startIndex < data.length - 1) {
        let destinationNextRecord =
          data[
            data.findIndex((item: any) => item.index === this.projectWholesaleeditData.index) + 1
          ];
        const lastItemNextRecord = this.myProjectScenarioWholesaleForm.value.destination;
        try {
          await this.getCalculateDisForNextRecord(lastItemNextRecord.name, destinationNextRecord);
          Object.freeze(destinationNextRecord);
          const objCopy = { ...destinationNextRecord };
          objCopy.distance = this.setManualLocationDisForNextRecord;
          destinationNextRecord = objCopy;
          this.projectFacade.locationProcessWholesaleActions(destinationNextRecord, 'edit');
        } catch (error) {
          // Handle error, e.g., log it or show a user-friendly message.
          console.error('Error:', error);
        }
      }
    });
  }

  deleteSetDistanceRecord(allRecorsds: any, deleteRecord: any) {
    this.projectFacade.locationWholesale$
      .pipe(take(1))
      .subscribe(async (allManualLocationData: any) => {
        const indexToDelete = allRecorsds.findIndex(
          (record: any) => record.index === deleteRecord.index
        );
        if (indexToDelete !== -1) {
          // Delete the record
          // Create a new array excluding the deleted record
          const newArray = allRecorsds.filter((record: any, index: any) => index !== indexToDelete);
          const aboveRecord = newArray[indexToDelete - 1];
          let belowRecord = newArray[indexToDelete];
          // newArray now contains the array with the specified record deleted
          if (belowRecord) {
            await this.getCalculateDisForNextRecord(aboveRecord.originName, belowRecord);
            Object.freeze(belowRecord);
            const objCopy = { ...belowRecord };
            objCopy.distance = this.setManualLocationDisForNextRecord;
            objCopy.index = allManualLocationData[indexToDelete].index;
            belowRecord = objCopy;
            this.projectFacade.locationProcessWholesaleActions(belowRecord, 'edit');
          }
        }
      });
  }

  seaDistanceMatrix(lastItem: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const fromCity = lastItem.originName;
      const toCity = this.myProjectScenarioWholesaleForm.controls['destination'].value?.name;
      const bothCity: string[] = [fromCity, toCity];
      const geocoder = new google.maps.Geocoder();

      // Use map to create an array of observables for geocoding requests
      const geocodeRequests = bothCity.map((address: string) => {
        return new Observable(observer => {
          geocoder.geocode({ address: address }, (results, status) => {
            if (status === 'OK') {
              const location = results![0].geometry.location;
              observer.next({ latitude: location.lat(), longitude: location.lng() });
              observer.complete();
            } else {
              observer.error(`Geocode was not successful for ${address} due to: ` + status);
            }
          });
        });
      });

      // Wait for all geocoding requests to complete
      forkJoin(geocodeRequests).subscribe(
        async (results: any[]) => {
          const [fromLocation, toLocation] = results;
          const latFrom = fromLocation.latitude;
          const lngFrom = fromLocation.longitude;
          const latTo = toLocation.latitude;
          const lngTo = toLocation.longitude;

          // Now you can make the API call
          const distanceType = this.sharedService.getDistanceTypeByTransportMode(
            this.transportModeId
          );
          const res = await this.sharedService.getDistanceAndTime(
            latFrom,
            lngFrom,
            latTo,
            lngTo,
            lastItem.originId,
            this.myProjectScenarioWholesaleForm.controls['destination'].value?.idStr,
            distanceType
          );
          if (
            this.transportModeId == commonEnum.AIR_INTERNATIONAL ||
            this.transportModeId == commonEnum.AIR_DOMESTIC
          ) {
            this.myProjectScenarioWholesaleForm.controls['distance'].setValue(
              formatNumber(res.data) + ' ' + 'km'
            );
            this.setManualLocationDis = formatNumber(res.data) + ' ' + 'km';
          } else if (this.transportModeId == commonEnum.SHIP_INTERNATIONAL) {
            this.seaDistance = formatNumber(res.data) + ' ' + 'km';
          }
          resolve(); // Resolve the promise once everything is done
        },
        error => {
          console.error(error);
          reject(error); // Reject the promise in case of an error
        }
      );
    });
  }

  async setDestination() {
    this.setDestinationsubmitted = true;

    if (
      !!this.myProjectScenarioWholesaleForm.controls['transportModeForLocation'].value &&
      this.myProjectScenarioWholesaleForm.controls['destination']?.value?.hasOwnProperty('name')
    ) {
      if (
        this.isCheckUpdateDestination &&
        this.myProjectScenarioWholesaleForm.controls['distanceManulaLocation'].value == 0
      ) {
        return;
      }
      if (
        (this.myProjectScenarioWholesaleForm.controls['destination']?.value?.name?.includes(
          'Port'
        ) &&
          (this.lastItem?.originName?.includes('Port') || this.lastItem?.name?.includes('Port')) &&
          this.transportModeName?.toLowerCase() == commonEnum.shipName) ||
        this.transportModeName?.toLowerCase() == commonEnum.airName ||
        this.transportModeName?.toLowerCase() == commonEnum.airDomesticName
      ) {
        await this.seaDistanceMatrix(this.lastItem);
      } else {
        !!this.transportModeId && (await this.calculateDistance(this.lastItem));
      }
      if (this.messageType != 1) {
        if (
          (this.myProjectScenarioWholesaleForm.value.destination?.idStr ||
            this.myProjectScenarioWholesaleForm.value.destination?.originId) ==
            this.projectWholesaleeditData?.originId &&
          this.transportModeId == this.projectWholesaleeditData?.transportModeId
        ) {
          this.setApiResDistance = true;
        }
        !!this.projectWholesaleeditData?.originId &&
          this.myProjectScenarioWholesaleForm.value.destination.idStr !=
            this.projectWholesaleeditData?.originId &&
          this.changeNextRecordDistance();
        const payload: any = {
          originName: this.myProjectScenarioWholesaleForm.controls['destination'].value.name,
          transportModeName:
            this.myProjectScenarioWholesaleForm.controls['transportModeForLocation'].value?.name,
          transportModeId:
            this.myProjectScenarioWholesaleForm.controls['transportModeForLocation'].value?.id,
          customTruckId: this.transportModeId
            ? this.transportModeId
            : this.projectWholesaleeditData.transportModeId,
          description:
            this.myProjectScenarioWholesaleForm.controls['transportModeForLocation'].value
              ?.description,
          originId:
            this.myProjectScenarioWholesaleForm.controls['destination'].value?.idStr ||
            this.myProjectScenarioWholesaleForm.controls['destination'].value?.originId,
          idStr:
            this.myProjectScenarioWholesaleForm.controls['destination'].value?.idStr ||
            this.myProjectScenarioWholesaleForm.controls['destination'].value?.originId,
          id: this.wholesaleData.id,
          isCustomTruck: this.isCustomTruck,
          isPalletLoad: this.isCalcByPalletOrigin,
          persanteageMassLoad:
            this.myProjectScenarioWholesaleForm.controls['percentLoadedOrigin'].value || 0,
          palletLoad: this.myProjectScenarioWholesaleForm.controls['palletLoadOrigin'].value,
          palletInTruck: this.myProjectScenarioWholesaleForm.controls['palletsInTruckOrigin'].value,
          loadInTruck: this.myProjectScenarioWholesaleForm.controls['loadInTruckOrigin'].value,
          maxLoad: this.maxLoad,
        };

        if (this.isCheckUpdateDestination) {
          payload['index'] = this.projectWholesaleeditData?.index;
        }

        const newManualLocationDisatance =
          this.myProjectScenarioWholesaleForm.controls['distanceManulaLocation'].value;
        const getDisType =
          typeof this.projectWholesaleeditData?.distance == 'string' &&
          !!this.projectWholesaleeditData?.distance
            ? this.projectWholesaleeditData?.distance?.substring(
                this.projectWholesaleeditData.distance.indexOf(' ') + 1
              )
            : 'km';
        const newVal = newManualLocationDisatance + ' ' + (getDisType == '0' ? ' ' : getDisType);

        if (this.transportModeName?.toLowerCase() == commonEnum.shipName) {
          payload['distance'] =
            this.isCheckUpdateDestination && this.setApiResDistance ? newVal : this.seaDistance;
        } else {
          payload['distance'] =
            this.isCheckUpdateDestination && this.setApiResDistance
              ? newVal
              : this.setManualLocationDis;
        }

        payload['isCheckManualDis'] = false;
        this.projectFacade.locationProcessWholesaleActions(
          payload,
          this.isCheckUpdateDestination ? 'edit' : 'add'
        );
        this.setDestinationsubmitted = false;
        this.isCheckUpdateDestination = false;
        this.setApiResDistance = false;
        this.projectWholesaleeditData = null;
        this.myProjectScenarioWholesaleForm.controls['destination'].reset();
        this.myProjectScenarioWholesaleForm.controls['transportModeForLocation'].reset();
        this.myProjectScenarioWholesaleForm.controls['percentLoadedOrigin'].setValue(0);
        this.myProjectScenarioWholesaleForm.controls['palletLoadOrigin'].setValue(0);
        this.myProjectScenarioWholesaleForm.controls['palletsInTruckOrigin'].setValue(0);
        this.myProjectScenarioWholesaleForm.controls['loadInTruckOrigin'].setValue(0);
        this.location = null;
        this.messageType = 0;
        this.isValidPort = '';
      } else if (this.messageType == 1) {
        this.myProjectScenarioWholesaleForm.controls['transportModeForLocation'].reset();
        this.setDestinationsubmitted = false;
        this.messageType = 0;
      } else {
        this.setDestinationsubmitted = true;
      }
    }
  }

  calcByPallet(event: any) {
    this.isCalcByPallet = event.target.checked ? true : false;
    const url = location.href.split('/');
    this.projectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
    this.isCalcByPallet
      ? this.projectsService
          .getLoadPerPallet(this.wholesaleData?.scenarioId, this.projectId)
          .subscribe((res: any) => {
            this.myProjectScenarioWholesaleForm.controls['palletLoad'].setValue(
              res.data?.loadInPallet
            );
          })
      : '';
  }

  calcByPalletOrigin(event: any) {
    this.isCalcByPalletOrigin = event.target.checked ? true : false;
    const url = location.href.split('/');
    const projectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
    this.isCalcByPalletOrigin
      ? this.projectsService
          .getLoadPerPallet(this.wholesaleData?.scenarioId, projectId)
          .subscribe((res: any) => {
            this.myProjectScenarioWholesaleForm.controls['palletLoadOrigin'].setValue(
              res.data?.loadInPallet
            );
          })
      : '';
  }

  refreshTruckList() {
    this.projectsService.getCustomTruckList().subscribe((res: any) => {
      this.customTransportModeList = res.data;
      this.transportModeList = this.isCustomTruck
        ? res.data
        : this.wholesaleData?.transportModeItems;
      this.transportModeListDistance = this.isCustomTruckDistance
        ? res.data
        : this.wholesaleData?.transportModeItems;
    });
  }

  getCustomTransport() {
    this.customService.getAllCustomTransportList().subscribe((res: any) => {
      this.transportFreightModeList = res.data;
    });
  }

  refreshWholesaleList() {
    this.customService.getAllCustomStorageList().subscribe((res: any) => {
      this.customWholesaleProcess = res.data.map((x: any) => {
        return { ...x, name: x.processName };
      });
      this.isProductContent
        ? (this.wholesaleProcess = this.customWholesaleProcess)
        : (this.wholesaleProcess = this.wholesaleData.storageIdentifierItems);
    });
  }

  selectEvent(event: any) {
    this.cityId = event.idStr;
    this.location = event.name;
    this.keywordAuto = '';
    this.selectedCities = [];
  }

  selectFreight(event: any) {
    this.projectFacade.clearFreightWholesale();
    if (event?.id) {
      this.customFreightSelectData = event;
    }
  }

  resetTransport() {
    this.customFreightSelectData = null;
  }

  addCustomFreight() {
    if (this.customFreightSelectData) {
      this.checkAddCustomFreight = true;
      this.customtransportScenarioId = this.customFreightSelectData.id;
      this.projectFacade.customFreightWholesaleActions(
        this.customtransportScenarioId,
        this.customFreightSelectData.isCustomSiteTransport
      );
    }
  }
  onScroll() {
    if (this.selectedCities?.length < 50) return;
    this.pageNumber++;
    this.isLoading = true;
    this.searchCities(this.searchValue);
  }
  onKeyDownEvent(event: any) {
    if (
      this.keywordAuto == undefined ||
      this.keywordAuto == null ||
      typeof this.keywordAuto == 'object'
    ) {
      this.keywordAuto = '';
    }
    onKeyDown(event, this.keywordAuto);
  }

  onSearch(searchValue: string) {
    if (this.keywordAuto == undefined || this.keywordAuto == null) {
      this.keywordAuto = '';
    }
    this.keywordAuto = this.keywordAuto?.trimStart();
    if (this.keywordAuto.length) {
      this.isLoading = true;
      this.pageNumber = 1;
      this.searchValue = this.keywordAuto;
      this.selectedCities = [];
      this.searchSubject.next(this.keywordAuto);
    }
  }

  onClearSearch(event: any) {
    this.isLoading = false;
    this.selectedCities = [];
    this.pageNumber = 1;
    this.searchValue = '';
    this.autoForOrigin?.close();
    this.autoForDestination?.close();
  }

  async searchCities(searchValue: string) {
    const res: any = await this.sharedService.getAllFilterCity(
      this.pageNumber,
      searchValue,
      this.isShowPort
    );
    this.selectedCities = this.pageNumber === 1 ? res.data : [...this.selectedCities, ...res.data];
    this.autoForOrigin?.focus();
    this.autoForDestination?.focus();
    this.isLoading = false;
  }

  showPorts(event: any) {
    this.myProjectScenarioWholesaleForm.controls['origin'].setValue(null);
    this.myProjectScenarioWholesaleForm.controls['destination'].setValue(null);
    this.isShowPort = event.target.checked;
  }

  addTransportLeg() {
    this.isDistance = true;
    if (
      (this.myProjectScenarioWholesaleForm.controls['distance'].value > 0 ||
        !!this.myProjectScenarioWholesaleForm.controls['distance'].value) &&
      !!this.myProjectScenarioWholesaleForm.controls['transportModeForDistance'].value
    ) {
      const payload: any = {
        transportModeName:
          this.myProjectScenarioWholesaleForm.controls['transportModeForDistance'].value?.name,
        transportModeId:
          this.myProjectScenarioWholesaleForm.controls['transportModeForDistance'].value?.id,
        persanteageMassLoad:
          this.myProjectScenarioWholesaleForm.controls['percentLoaded'].value || 0,
        distance: this.myProjectScenarioWholesaleForm.controls['distance'].value,
        customTruckId:
          this.myProjectScenarioWholesaleForm.controls['transportModeForDistance'].value?.id ||
          this.myProjectScenarioWholesaleForm.controls['transportModeForDistance'].value?.truckId,
        isCustomTruck: this.isCustomTruckDistance,
        description:
          this.myProjectScenarioWholesaleForm.controls['transportModeForDistance'].value
            ?.description,
        isPalletLoad: this.isCalcByPallet,
        palletLoad: this.myProjectScenarioWholesaleForm.controls['palletLoad'].value,
        palletInTruck: this.myProjectScenarioWholesaleForm.controls['palletsInTruck'].value,
        loadInTruck: this.myProjectScenarioWholesaleForm.controls['loadInTruck'].value,
        maxLoad: this.maxLoad,
      };
      if (this.isCheckEditManudalDist) {
        payload['index'] = this.projectWholesaleeditData.index;
      }
      payload['isCheckManualDis'] = true;
      this.isDistance = false;
      this.projectFacade.distanceWholesaleActions(
        payload,
        this.isCheckEditManudalDist ? 'edit' : 'add',
        this.isDistance
      );
      this.isCheckEditManudalDist = false;
      this.projectWholesaleeditData = null;
      this.myProjectScenarioWholesaleForm.controls['transportModeForDistance'].reset();
      this.myProjectScenarioWholesaleForm.controls['distance'].reset();
      this.myProjectScenarioWholesaleForm.controls['percentLoaded'].setValue(0);
      this.myProjectScenarioWholesaleForm.controls['palletsInTruck'].setValue(0);
      this.myProjectScenarioWholesaleForm.controls['palletLoad'].setValue(0);
      this.myProjectScenarioWholesaleForm.controls['loadInTruck'].setValue(0);
    }
  }

  toggleCustomStorage(eve: any) {
    this.isProductContent = eve.target.checked ? true : false;
    if (this.isProductContent) {
      this.myProjectScenarioWholesaleForm.controls['storageItems'].setValue(
        this.selectedCustomStorageItem
      );
      this.wholesaleProcess = this.customWholesaleProcess;
    } else {
      this.myProjectScenarioWholesaleForm.controls['storageItems'].setValue(
        this.selectedWholesaleItem
      );
      this.wholesaleProcess = this.wholesaleData.storageIdentifierItems;
    }
  }

  changeProductLoss(event: any, type: 'clear' | 'change') {
    if (type == 'change' && event?.id) {
      this.secondaryMarketDropdown = event.name == this.secondaryMarketStr ? true : false;
    } else {
      this.secondaryMarketDropdown = false;
    }
  }

  async setStorageValue() {
    if (this.wholesaleData.isCustomStorage) {
      await this.wholesaleData?.customStorageItems?.map((item: any) => {
        if (item.idStr == this.wholesaleData?.customStorageId) {
          return (this.selectedStorageItem = item);
        }
      });
    } else {
      await this.wholesaleProcess.map((item: any) => {
        if (item.id == this.wholesaleData?.storageIdentifierId) {
          return (this.selectedStorageItem = item);
        }
      });
    }
  }

  async setCountryValue() {
    await this.regionListData.map((item: any) => {
      if (item.id == this.wholesaleData?.regionId) {
        this.selectedRegion = item.name;
      }
    });
  }

  async setPackagingLossValue() {
    await this.endOfLifeList.map((item: any) => {
      if (item.id == this.wholesaleData?.endofLifeIdentifierId) {
        return (this.selectedPackagingLossItem = item);
      }
    });
  }

  async setProductLossValue() {
    await this.productLossItems.map((item: any) => {
      if (item.id == this.wholesaleData?.productLossWasteDisposalId) {
        this.secondaryMarketDropdown = item?.name == this.secondaryMarketStr ? true : false;
        return (this.selectedProductLossItem = item);
      }
    });
  }

  setFormValues() {
    this.myProjectScenarioWholesaleForm.patchValue({
      storageItems: this.selectedStorageItem,
      storageDays: this.wholesaleData.storageDays,
      regionList: this.selectedRegion,
      productLossList: this.selectedProductLossItem,
      endOfLifeItems: this.selectedPackagingLossItem,
      percentageProductLoss: this.wholesaleData.percentageProductLoss,
    });
    if (this.wholesaleData.isCustomStorage) {
      this.isProductContent = true;
      this.wholesaleProcess = this.customWholesaleProcess;
    } else {
      this.isProductContent = false;
      this.wholesaleProcess = this.wholesaleData.storageIdentifierItems;
    }
    switch (this.selectedBox?.id) {
      case 2:
        this.wholeData[0]['img'] = this.loactionWhite;
        this.selectLocation = true;
        break;
      case 3:
        this.wholeData[1]['img'] = this.distanceWhite;
        this.selectDistance = true;
        break;
      case 4:
        this.wholeData[2]['img'] = this.customWhite;
        this.selectCustom = true;
        break;
      default:
        break;
    }
  }

  selectChange(eve: any) {
    if (eve?.id || eve?.idStr) {
      if (this.isProductContent) {
        this.selectedCustomStorageItem = eve;
      } else {
        this.selectedWholesaleItem = eve;
      }
    }
  }

  productLossValue(event: any) {
    if (event.target.value > 0) {
      this.myProjectScenarioWholesaleForm.controls['productLossList'].setValidators(
        Validators.required
      );
      this.myProjectScenarioWholesaleForm.controls['endOfLifeItems'].setValidators(
        Validators.required
      );
    } else {
      this.myProjectScenarioWholesaleForm.controls['productLossList'].removeValidators(
        Validators.required
      );
      this.myProjectScenarioWholesaleForm.controls['endOfLifeItems'].removeValidators(
        Validators.required
      );
    }
    this.myProjectScenarioWholesaleForm.controls['endOfLifeItems'].updateValueAndValidity();
    this.myProjectScenarioWholesaleForm.controls['productLossList'].updateValueAndValidity();
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  commonInputSearchForCountry(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  onClose() {
    this.modal.close();
    this.projectFacade.clearDefaultMaterial();
    this.projectFacade.clearFreightWholesale();
    this.projectFacade.clearDistanceWholesale();
    this.projectFacade.clearLocationWholesale();
  }

  onSave(locationData: any, distance: any, customFreight: any) {
    this.submitted = true;
    const url = location.href.split('/');
    const projectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
    if (this.selectLocation) {
      locationData = locationData;
      distance = [];
      this.customtransportScenarioId = undefined;
    } else if (this.selectDistance) {
      distance = distance;
      locationData = [];
      this.customtransportScenarioId = undefined;
    } else {
      locationData = [];
      distance = [];
    }
    if (locationData) {
      locationData = locationData.map((item: any) => {
        if (typeof item.distance === 'string' && item.distance != 0) {
          const type = item.distance?.substring(item.distance.indexOf(' ') + 1);
          Object.freeze(item);
          const objCopy = { ...item };
          const distanceWithoutCommas = item.distance.replace(/,/g, '');
          objCopy.distance = parseFloat(distanceWithoutCommas);
          objCopy.unit = type;
          item = objCopy;
        } else {
          Object.freeze(item);
          const objCopy = { ...item };
          objCopy.unit = 'km';
          item = objCopy;
        }
        return item;
      });
    }

    if (distance) {
      distance = distance.map((item: any) => {
        return {
          ...item,
          unit: 'km',
        };
      });
    }
    if (
      this.myProjectScenarioWholesaleForm.valid &&
      this.myProjectScenarioWholesaleForm.controls['volumeRatio'].value > 0
    ) {
      const payload: any = {
        id: this.wholesaleData?.id || 0,
        // palletTypeId: this.myProjectScenarioWholesaleForm.controls['pallet'].value?.id,
        storageTypeId: 1,
        endofLifeIdentifierId:
          this.myProjectScenarioWholesaleForm.controls['endOfLifeItems'].value?.id,
        locationTransportationItems: locationData,
        distanceTransportationItems: distance,
        packageScenarioId: this.wholesaleData.packageScenarioId,
        storageDays: this.myProjectScenarioWholesaleForm.controls['storageDays'].value,
        regionId:
          this.myProjectScenarioWholesaleForm.controls['regionList'].value?.id ||
          this.wholesaleData.regionId,
        customtransportScenarioId: this.checkAddCustomFreight
          ? this.customtransportScenarioId
          : undefined,
        percentageProductLoss:
          this.myProjectScenarioWholesaleForm.controls['percentageProductLoss'].value,
        cost: this.myProjectScenarioWholesaleForm.controls['wholesaleCost'].value,
        transportationId: this.transportaionId || this.wholesaleData.transportationId,
        scenarioId: this.packageScenarioId,
        volumeRatio:
          this.myProjectScenarioWholesaleForm.controls['volumeRatio'].value ||
          this.wholesaleData?.volumeRatio,
        storageIdentifierId:
          this.selectedWholesaleItem?.id ||
          this.myProjectScenarioWholesaleForm.controls['storageItems'].value?.id,
        isCustomStorage: this.isProductContent, //For custom storage,
        customStorageId:
          Number(this.selectedCustomStorageItem?.idStr) ||
          this.selectedCustomStorageItem?.id ||
          this.wholesaleData?.customStorageId,
        productLossWasteDisposalId:
          this.myProjectScenarioWholesaleForm.controls['productLossList'].value?.id,
        projectId: projectId,
        isCustomTruck: this.transportaionId == 2 ? this.isCustomTruck : this.isCustomTruckDistance,
      };
      if (this.secondaryMarketDropdown) {
        payload['percentageOfReusedProduct'] =
          this.myProjectScenarioWholesaleForm.controls['secondaryMarket'].value?.name ||
          this.myProjectScenarioWholesaleForm.controls['secondaryMarket'].value;
      } else {
        payload['percentageOfReusedProduct'] = 0;
      }
      this.saveNewMyProjectWholesaleEvent.emit(payload);
      this.checkAddCustomFreight = false;
      this.modal.close();
      this.projectFacade.clearFreightWholesale();
      this.projectFacade.clearDistanceWholesale();
      this.projectFacade.clearLocationWholesale();
    }
  }

  closePopup(step?: string) {
    if (step == 'one') {
      this.popoverOne.close();
      this.popoverTwo.open();
    } else {
      this.popoverTwo.close();
      scrollToSpecific('org-top');
      this.sharedService.updateGuideTourStatus(GuideTourEnum.WholesaleTour, true).subscribe();
    }
  }

  goBack() {
    this.popoverTwo.close();
    this.popoverOne.open();
  }

  triggerPopup() {
    setTimeout(() => {
      scrollToSpecific('popover-one');
      this.popoverOne.open();
    }, 0);
  }

  ngAfterViewInit() {
    if (!this.wholesaleData.isTourCompleted) this.triggerPopup();
  }

  closeAllSteps(stepNum: any) {
    this.popoverOne.close();
    this.popoverTwo.close();
    this.sharedService
      .updateGuideTourStatus(GuideTourEnum.WholesaleTour, false, stepNum)
      .subscribe();
  }

  ngOnDestroy() {
    this.projectFacade.clearaddTransportScenarioForPackMaterialForConversion();
    this.searchSubject.complete();
  }
}
